import gql from 'graphql-tag'

export const DOCTOR_CREATE_WORKSCHEDULE_OVERTIME = gql`
  mutation doctorCreateWorkScheduleOverTime(
    $workScheduleId: ID!
    $data: WorkScheduleOvertimeCreateWithoutWorkScheduleInput!
  ) {
    doctorCreateWorkScheduleOverTime(
      workScheduleId: $workScheduleId
      data: $data
    ) {
      id
    }
  }
`

export const DOCTOR_WITHDRAW_WORKSCHEDULE_OVERTIME = gql`
  mutation doctorWithdrawWorkScheduleOverTime($workOverTimeId: ID!) {
    doctorWithdrawWorkScheduleOverTime(workOverTimeId: $workOverTimeId) {
      id
      status
    }
  }
`
